























































import newButton from '@/components/Reusable/NewButton.vue';
import DatesFormat from '@/util/classes/datesFormat';
import { tCashbackParams } from '@/store/interfaces/cashback';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { TableRef } from '@/store/interfaces/generic';
import cashback from '@/store/types/cashback';
import { TeipNotifications } from '@/util/teipNotifications';
import SweetAlert from '@/util/classes/SweetAlert';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
const formatDate = new DatesFormat();

export default Vue.extend({
  name: 'CashbackList',
  components: {
    newButton,
  },
  data: () => ({
    viewDetails: false,
    propsToSearch: [] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'name',
        label: 'Nombre',
        minWidth: 250,
        sortable: true,
      },
      {
        prop: 'cashback_type',
        label: 'Alcance',
        minWidth: 250,
        sortable: true,
        formatter: (row: tCashbackParams): string => {
          const discountTypes = {
            regular: 'Todos',
            sign_up: 'Solo primera transacción',
          };
          return discountTypes[row.cashback_type] ?? 'Desconocido';
        },
      },
      {
        prop: 'start_at',
        label: 'Fecha de inicio',
        minWidth: 150,
        sortable: true,
        formatter: (row: tCashbackParams): string => {
          return `${formatDate.formatDateTime(row.start_at)}`;
        },
      },
      {
        prop: 'end_at',
        label: 'Fecha Fin',
        minWidth: 150,
        sortable: true,
        formatter: (row: tCashbackParams): string => {
          return `${formatDate.formatDateTime(row.end_at)}`;
        },
      }
    ] as tTableColumns,
    rowSelected: {
      id: '',
      name: '',
      start_at: '',
      end_at: '',
      description: null,
      kind: 'individual',
      bonus: 'percentage',
      network: 'all',
      participation: 'platform',
      cap: 'all',
      amount_cents: 0,
      amount_currency: '',
      budget_cents: 0,
      budget_currency: '',
      platform_participation_percentage: 0,
      commerce_participation_percentage: 0,
      occurrences_count: 0,
      percentage: 0,
      created_at: '',
      minimum_amount_cents: 0,
      minimum_amount_currency: '',
      maximum_amount_cents: 0,
      maximum_amount_currency: '',
      ceiling_amount_cents: 0,
      ceiling_amount_currency: '',
      range_minimum_amount_cents: 0,
      range_minimum_amount_currency: '',
      range_maximum_amount_cents: 0,
      range_maximum_amount_currency: '',
      user_occurrences_count: 0,
      rules: [],
      cashback_type: 'regular',
      user: undefined,
      cashback_order_kind: undefined,
    } as tCashbackParams,
  }),
  computed: {
    ...mapGetters({
      getCashbackList: `cashback/${cashback.getters.GET_CASHBACK}`,
    }),
  },
  methods: {
    ...mapActions({
      CashbackList: `cashback/${cashback.actions.CASHBACK_LIST}`,
      DeleteCashback: `cashback/${cashback.actions.DELETE_CASHBACK}`,
    }),
    rowselect(row: tCashbackParams): void {
      this.rowSelected = row;
    },
    updateCashback(): void {
      this.$router.push({
        name: 'CashbackUpdate',
        params: {
          id: this.rowSelected.id,
        },
      });
    },
    deleteCashback(): void {
      const notification = new TeipNotifications();
      const swal = new SweetAlert();
      swal
        .askingSweetAlert({
          title: 'Eliminar cashback',
          text: '¿Seguro que desea eliminar el cashback?',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sí, eliminar',
          alertType: 'warning',
        })
        .then((res) => {
          res &&
            this.DeleteCashback(this.rowSelected.id)
              .then(() => {
                notification.success('Cashback eliminado con éxito');
                (this.$refs.refCashbackList as TableRef).fetchData();
              })
              .catch(() => {
                notification.warning(':(', 'No se pudo eliminar el cashback');
              });
        });
    },
  },
});
